import React, { useState, useEffect } from 'react';
import { Input, Button, Flex, message } from 'antd';
import { EditOutlined, CloseOutlined } from '@ant-design/icons';

const EmailTemplate = ({ orderData, setEmailData, setIsEmailTemplateChanged, isEmailTemplateChanged }) => {
    // Initial values
    let initialSubject = ''
    switch (orderData?.status) {
        case "on-hold":
            initialSubject = `Order# ${orderData?.number} on-hold`;
            break;
        case "refunded":
            initialSubject = `Order# ${orderData?.number} refunded`;
            break;
        case "completed":
            initialSubject = `Order# ${orderData?.number} Confirmed`;
            break;
        case "shipped":
            initialSubject = `Order# ${orderData?.number} shipped`;
            break;
        default:
            initialSubject = `Order# ${orderData?.number} processed`;
    }

    const statusOptions = ["auto-draft", "shipped", "pending", "processing", "on-hold", "completed", "cancelled", "refunded", "failed"];


    const initialStatusText = orderData?.status === 'on-hold'
        ? `Your order is currently on hold due to ${orderData?.meta_data?.find((item) => item.key === 'on_hold_reason')?.value || 'some reasons'}`
        : orderData?.status === 'refunded'
            ? `Your order has been refunded due to ${orderData?.meta_data?.find((item) => item.key === 'on_refunded_reason')?.value || 'some reasons'}`
            : orderData?.status === 'completed'
                ? 'Your order has successfully completed! We hope you are happy with your purchase.'
                : orderData?.status === 'shipped'
                    ? 'Great news! Your order has been shipped and is on its way to you.'
                    : 'Thank you for your purchase! We’re currently processing your order and will notify you once it’s shipped.';

    const initialOrderStatus = `Your Order #${orderData.number} is Now ${orderData.status}`;

    const [showStatusText, setShowStatusText] = useState(initialStatusText);
    const [orderStatus, setOrderStatus] = useState(initialOrderStatus);
    const [eamilSubject, setEamilSubject] = useState(initialSubject);

    const [isOrderStatusEditing, setIsOrderStatusEditing] = useState(false);
    const [isShowStatusTextEditing, setIsShowStatusTextEditing] = useState(false);
    const [isSubjectEditiing, setIsSubjectEditing] = useState(false);


    useEffect(() => {
        setEmailData((pre) => {
            pre.subject = initialSubject
            pre.heading && setOrderStatus(pre.heading)
            pre.statusBasesText && setShowStatusText(pre.statusBasesText)
            let result = {
                subject: pre?.subject === eamilSubject ? eamilSubject : pre?.subject,
                heading: pre?.heading === orderStatus ? orderStatus : pre?.heading,
                statusBasesText: pre?.statusBasesText === showStatusText ? showStatusText : pre?.statusBasesText
            }
            pre = result
            return pre;
        })
    }, [])

    const handleStatusChange = (e) => {
        setShowStatusText(e.target.value);
        isEmailTemplateChanged || setIsEmailTemplateChanged(true)
    };

    const handleOrderStatusChange = (e) => {
        setOrderStatus(e.target.value);
        isEmailTemplateChanged || setIsEmailTemplateChanged(true)

    };

    const toggleOrderStatusEdit = () => {
        setIsOrderStatusEditing(!isOrderStatusEditing);
    };

    const toggleShowStatusTextEdit = () => {
        setIsShowStatusTextEditing(!isShowStatusTextEditing);
    };

    const closeOrderStatusEdit = () => {
        setIsOrderStatusEditing(false);
    };

    const closeShowStatusTextEdit = () => {
        setIsShowStatusTextEditing(false);
    };
    const closeShowSubjectTextEdit = () => {
        setIsSubjectEditing(false);

    };

    const resetValues = () => {
        setShowStatusText(initialStatusText);
        setOrderStatus(initialOrderStatus);
        setEamilSubject(initialSubject);
        setIsOrderStatusEditing(false);
        setIsShowStatusTextEditing(false);
        setIsShowStatusTextEditing(setIsSubjectEditing);
    };

    const handleKeyDown = (e, isStatus) => {
        if (e.key === 'Enter' && isStatus === 1) {
            closeOrderStatusEdit()
        } else if (e.key === 'Enter' && !isStatus) {
            closeShowStatusTextEdit();
        }
        else if (e.key === 'Enter' && isStatus === 2) {
            closeShowSubjectTextEdit()
        }
    };
    const saveTemplate = () => {
        // let isSubjectValid = (eamilSubject?.toLowerCase() ?? '').includes((orderData?.status?.toLowerCase() ?? ''));
        // if (!isSubjectValid) {
        //     return message.warning('you must include order status in subject')
        // }
        setEmailData({
            subject: initialSubject,
            heading:orderStatus || initialOrderStatus,
            statusBasesText:showStatusText || initialStatusText
        })
        setIsEmailTemplateChanged(false)
    }
    return (
        <div className="container" style={{ overflowY: 'scroll', height: '600px', width: '100%', maxWidth: '700px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <div className="logo" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Flex style={{ flex: 1, justifyContent: 'center' }}>
                    <img src="https://gearvana.com/wp-content/uploads/2021/10/Gearvana-Marketplace-Logo.png" alt="GearVana Marketplace" style={{ width: '150px' }} />
                </Flex>
                <Button onClick={saveTemplate} type="primary" style={{ background: "#1677ff", color: "white" }}>Save Template</Button>
            </div>

            <div style={{ textAlign: 'start', marginBottom: '20px', fontSize: '16px', fontWeight: 'bold', color: 'grey' }}>
                {/* {isSubjectEditiing ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input
                            value={eamilSubject}

                            onChange={(e) => {
                                (eamilSubject && !isEmailTemplateChanged) && setIsEmailTemplateChanged(true)
                                setEamilSubject(e.target.value)
                            }}
                            onBlur={(e) => setEamilSubject(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 2)}
                            autoFocus
                        />
                        <CloseOutlined
                            onClick={closeShowSubjectTextEdit}
                            style={{ marginLeft: '8px', cursor: 'pointer' }}
                        />
                    </div>
                ) : (
                    <p onClick={() => { setIsSubjectEditing(true) }}>
                        Subject: {eamilSubject} <EditOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                    </p>
                )} */}
            </div>
            <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>
                {isOrderStatusEditing ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input
                            value={orderStatus}
                            onChange={handleOrderStatusChange}
                            onBlur={handleOrderStatusChange}
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            autoFocus
                        />
                        <CloseOutlined
                            onClick={closeOrderStatusEdit}
                            style={{ marginLeft: '8px', cursor: 'pointer' }}
                        />
                    </div>
                ) : (
                    <p onClick={toggleOrderStatusEdit}>
                        {orderStatus} <EditOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                    </p>
                )}
            </div>

            {/* Editable Order Status Message */}
            <div style={{ fontSize: '16px', marginBottom: '20px' }}>
                {isShowStatusTextEditing ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input
                            value={showStatusText}
                            onChange={handleStatusChange}
                            onBlur={handleStatusChange}
                            onKeyDown={handleKeyDown} // Add the keydown handler here
                            autoFocus
                        />
                        <CloseOutlined
                            onClick={closeShowStatusTextEdit}
                            style={{ marginLeft: '8px', cursor: 'pointer' }}
                        />
                    </div>
                ) : (
                    <p onClick={toggleShowStatusTextEdit}>
                        {showStatusText} <EditOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                    </p>
                )}
            </div>

            {/* Order Summary Table */}
            <div className="order-summary" style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '18px', marginBottom: '10px' }}>Order Summary</h3>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table className="summary-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        {orderData.line_items?.map(item => (
                            <tr key={item.id} style={{ borderBottom: '1px solid #ddd' }}>
                                <td style={{ padding: '8px', fontSize: '14px' }}>
                                    <img src={item?.image?.src} alt="Product Image" style={{ width: '50px', verticalAlign: 'middle', marginRight: '10px' }} />
                                    {item.name} × {item.quantity}
                                </td>
                                <td align="right" style={{ padding: '8px', fontSize: '14px' }}>
                                    {item.price}{orderData.currency_symbol}
                                </td>
                            </tr>
                        ))}
                        <tr style={{ borderTop: '1px solid #ddd', fontWeight: 'bold' }}>
                            <td style={{ padding: '8px' }}>Subtotal</td>
                            <td align="right" style={{ padding: '8px' }}>
                                {orderData.total}{orderData.currency_symbol}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Shipping</td>
                            <td align="right" style={{ padding: '8px' }}>
                                {orderData.shipping_total}{orderData.currency_symbol}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Taxes</td>
                            <td align="right" style={{ padding: '8px' }}>
                                {orderData.total_tax}{orderData.currency_symbol}
                            </td>
                        </tr>
                        <tr style={{ fontWeight: 'bold' }}>
                            <td style={{ padding: '8px' }}>Total</td>
                            <td align="right" style={{ padding: '8px' }}>
                                {orderData.total}{orderData.currency_symbol}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className="customer-info" style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '18px', marginBottom: '10px' }}>Customer Information</h3>
                <p><strong>Shipping Address</strong></p>
                <p>{orderData.shipping.first_name} {orderData.shipping.last_name}</p>
                <p>{orderData.shipping.address_1}, {orderData.shipping.address_2}</p>
                <p><strong>Billing Address</strong></p>
                <p>{orderData.billing.first_name} {orderData.billing.last_name}</p>
                <p>{orderData.billing.address_1}, {orderData.billing.address_2}</p>
                <p><strong>Payment</strong>: {orderData.payment_method_title}</p>
                <p><strong>Shipping Method</strong>: {orderData.shipping_lines[0]?.method_title}</p>
            </div>
            <p>If you have any questions, feel free to reply to this email.</p>
            <p className="footer" style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: '#666' }}>
                Best Regards,<br />Gearvana Marketplace
            </p>
            <div style={{ textAlign: 'center' }}>
                <Button onClick={resetValues} type="default" style={{ marginTop: '20px' }}>
                    Reset
                </Button>
            </div>
        </div>
    );
};

export default EmailTemplate;
